export const socratesAPIEndpoint = "https://socratesqa.nexrepapps.com/SocratesAPI/api";
//export const socratesAPIEndpoint = "https://socrates.nexrepapps.com/SocratesAPI/api";


//export const socratesAPIEndpoint = "http://localhost/SocratesAPI/api";
